import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { cx } from "../utils/cx";

function StatCard({ icon: Icon, label, value, hint, trend, tone = "brand" }) {
  return (
    <article className={cx("stat-card", `tone-${tone}`)}>
      <div className="stat-card-top">
        <div>
          <p className="stat-label">{label}</p>
          <p className="stat-value">{value}</p>
        </div>

        {Icon ? (
          <div className="stat-icon">
            <Icon size={18} />
          </div>
        ) : null}
      </div>

      {hint || trend ? (
        <div className="stat-footer">
          {trend ? (
            <span className={cx("trend-pill", trend.direction === "down" && "is-down")}>
              {trend.direction === "down" ? (
                <ArrowDownRight size={14} />
              ) : (
                <ArrowUpRight size={14} />
              )}
              {trend.label}
            </span>
          ) : null}
          {hint ? <span className="stat-hint">{hint}</span> : null}
        </div>
      ) : null}
    </article>
  );
}

export default StatCard;
